/**
 * Team, Onboarding (plan docs/plans/lms-plan.md 12.2, 12.3, 12.4, section 13
 * tab 6, 18.24; WP-47; R1, R14).
 *
 * Replaces WP-03's placeholder in place: tabs/team/subviews.ts imports this
 * file's DEFAULT export (a component with no props), mounted under the Team
 * tab's PageHeader and SegmentedTabs at /lms/team/onboarding/* (plan 18.3),
 * so it routes its own deeper path:
 *
 *   /lms/team/onboarding          the runs, "Start onboarding" (RunList)
 *   /lms/team/onboarding/:runId   one run: every item with the controls,
 *                                 verify, notes, cancel (RunPage)
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import RunList from './RunList';
import { RunPageRoute } from './RunPage';
import { RUNS_BASE } from './paths';

export function OnboardingRunsView() {
  return (
    <Routes>
      <Route index element={<RunList />} />
      <Route path=":runId" element={<RunPageRoute />} />
      <Route path="*" element={<Navigate to={RUNS_BASE} replace />} />
    </Routes>
  );
}

export default OnboardingRunsView;
